import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import { HuchaBonusPdf } from './hucha-bonus-pdf';
import { RenovadoresBonusPdf } from './renovadores-bonus-pdf';

export const HuchaPDFContent = ({
	targetRef,
	huchaValues,
}: {
	targetRef: React.RefObject<HTMLDivElement>;
	huchaValues: HuchaValues | null;
}) => {
	const layerContent = () => {
		if (huchaValues?.isRenovador) {
			return <RenovadoresBonusPdf huchaValues={huchaValues} />;
		} else {
			return <HuchaBonusPdf huchaValues={huchaValues} />;
		}
	};
	return (
		<div
			ref={targetRef}
			style={{
				position: 'absolute',
				left: '-9999px',
				width: '1024px',
				overflow: 'visible',
				pageBreakInside: 'avoid',
				breakInside: 'avoid',
			}}
		>
			{layerContent()}
		</div>
	);
};
